const KNOWN_ADDRESS_TYPE_ALIASES = {
  correspondence: "correspondence",
  residental: "residental",
  registeredoffice: "registeredOffice",
  contract: "contract",
  other: "other",
};

const canonicalAddressType = (type) => {
  const lowered = String(type ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "");
  if (!lowered) return "";
  return KNOWN_ADDRESS_TYPE_ALIASES[lowered] ?? lowered;
};

const splitAddressTypeLabels = (value) => {
  if (Array.isArray(value)) {
    return value.flatMap((item) => splitAddressTypeLabels(item));
  }
  return String(value ?? "")
    .split("+")
    .map((part) => part.trim())
    .filter(Boolean);
};

export const readAddressTypes = (address) => {
  if (!address || typeof address !== "object") return [];
  const source =
    Array.isArray(address.types) && address.types.length ? address.types : address.type;
  const types = [];
  splitAddressTypeLabels(source).forEach((item) => {
    const normalized = canonicalAddressType(item);
    if (normalized && !types.includes(normalized)) types.push(normalized);
  });
  return types;
};

export const addressTypeLabel = (address) => {
  const types = readAddressTypes(address);
  if (types.length) return types.join(" + ");
  return String(address?.type ?? "").trim();
};
